export default window.location.pathname.startsWith("/extension");
